import { render } from "./indexKanban.vue?vue&type=template&id=3265475e"
import script from "./indexKanban.vue?vue&type=script&lang=js"
export * from "./indexKanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__